import { ClearStorageLogout } from "../config/localstorageConfig/localstorage";

export const logout = () => {
  //localStorage.removeItem(TOKEN_KEY);
  //localStorage.clear();
  ClearStorageLogout();
};


